import { useEffect } from 'react';

type UseForceRedirectProps = {
  redirectTo: string | null;
};

export const useForceRedirect = ({ redirectTo }: UseForceRedirectProps) => {
  useEffect(() => {
    if (redirectTo) {
      try {
        const url = new URL(redirectTo);
        window.location.assign(url);
      } catch (e) {
        // invalid URL provided
      }
    }
  }, [redirectTo]);
};
